/**
 * Web Audio API sound effects — ported from v1 bamford.html.
 * All sounds synthesized (no external audio files).
 */

let audioCtx: AudioContext | null = null

function ctx(): AudioContext {
  if (!audioCtx) audioCtx = new AudioContext()
  // Resume if suspended (browser autoplay policy)
  if (audioCtx.state === 'suspended') audioCtx.resume()
  return audioCtx
}

export function playCheer(): void {
  const ac = ctx()
  const t = ac.currentTime;
  [523, 659, 784, 1047].forEach((freq, i) => {
    const osc = ac.createOscillator()
    const gain = ac.createGain()
    osc.type = 'triangle'
    osc.frequency.value = freq
    gain.gain.setValueAtTime(0.15, t + i * 0.12)
    gain.gain.exponentialRampToValueAtTime(0.01, t + i * 0.12 + 0.4)
    osc.connect(gain); gain.connect(ac.destination)
    osc.start(t + i * 0.12); osc.stop(t + i * 0.12 + 0.4)
  })
  // Crowd noise (white noise burst)
  const buf = ac.createBuffer(1, ac.sampleRate * 0.8, ac.sampleRate)
  const data = buf.getChannelData(0)
  for (let i = 0; i < data.length; i++) data[i] = (Math.random() * 2 - 1) * 0.15
  const noise = ac.createBufferSource()
  const nGain = ac.createGain()
  noise.buffer = buf
  nGain.gain.setValueAtTime(0.12, t)
  nGain.gain.exponentialRampToValueAtTime(0.01, t + 0.8)
  noise.connect(nGain); nGain.connect(ac.destination)
  noise.start(t + 0.15)
}

export function playBounce(): void {
  const ac = ctx()
  const t = ac.currentTime
  const osc = ac.createOscillator()
  const gain = ac.createGain()
  osc.type = 'square'
  osc.frequency.setValueAtTime(800, t)
  osc.frequency.exponentialRampToValueAtTime(200, t + 0.15)
  gain.gain.setValueAtTime(0.2, t)
  gain.gain.exponentialRampToValueAtTime(0.01, t + 0.2)
  osc.connect(gain); gain.connect(ac.destination)
  osc.start(t); osc.stop(t + 0.2)
}

export function playSad(): void {
  const ac = ctx()
  const t = ac.currentTime;
  [400, 300, 200].forEach((freq, i) => {
    const osc = ac.createOscillator()
    const gain = ac.createGain()
    osc.type = 'sine'
    osc.frequency.setValueAtTime(freq + 50, t + i * 0.25)
    osc.frequency.exponentialRampToValueAtTime(freq - 50, t + i * 0.25 + 0.2)
    gain.gain.setValueAtTime(0.15, t + i * 0.25)
    gain.gain.exponentialRampToValueAtTime(0.01, t + i * 0.25 + 0.25)
    osc.connect(gain); gain.connect(ac.destination)
    osc.start(t + i * 0.25); osc.stop(t + i * 0.25 + 0.3)
  })
}

export function playHit(): void {
  const ac = ctx()
  const t = ac.currentTime
  const osc = ac.createOscillator()
  const gain = ac.createGain()
  osc.type = 'sine'
  osc.frequency.value = 220
  gain.gain.setValueAtTime(0.1, t)
  gain.gain.exponentialRampToValueAtTime(0.01, t + 0.15)
  osc.connect(gain); gain.connect(ac.destination)
  osc.start(t); osc.stop(t + 0.15)
}
